import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Returns_ds_get_serialnumbers_by_outboundShipmentIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { outboundShipmentId: number }): 
  Promise<{ result: { Id?: number, ChainHead?: number, LicensePlateId?: number, LotId?: number, PackagingId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.outboundShipmentId)) {
      missingRequiredInParams.push('\'outboundShipmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_get_serialnumbers_by_outboundShipmentId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { outboundShipmentId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ChainHead?: number, LicensePlateId?: number, LotId?: number, PackagingId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.outboundShipmentId)) {
      missingRequiredInParams.push('\'outboundShipmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_get_serialnumbers_by_outboundShipmentId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { outboundShipmentId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ChainHead?: number, LicensePlateId?: number, LotId?: number, PackagingId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.outboundShipmentId)) {
      missingRequiredInParams.push('\'outboundShipmentId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_get_serialnumbers_by_outboundShipmentId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      outboundShipmentId: number    }) {
        if(isNil(inParams.outboundShipmentId)) {
          return true; 
        }
      return false;
    }
}
